import { render } from "./VideoScreen.vue?vue&type=template&id=5978120a&scoped=true"
import script from "./VideoScreen.vue?vue&type=script&lang=js"
export * from "./VideoScreen.vue?vue&type=script&lang=js"

import "./VideoScreen.vue?vue&type=style&index=0&id=5978120a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5978120a"]])

export default __exports__